/* eslint-disable @typescript-eslint/naming-convention */
import type { Grid } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSHTML, CMSImage, CMSLinkedImage } from '@swf/cms';

import styles from './CMSGrid.scss';

const CMSGrid: React.FC<Grid> = ({ linked_image, html }) => (
  <div className={styles.grid}>
    {linked_image.link.url ? (
      <CMSLinkedImage {...linked_image} className={styles.gridLinkedImg} />
    ) : (
      <CMSImage
        {...linked_image.image}
        className={styles.image}
        logged_in_image={linked_image?.logged_in_linked_image?.image}
      />
    )}
    <CMSHTML {...html} className={styles.gridText} />
  </div>
);

export default CMSGrid;
